import React, { useState, useContext, useEffect } from 'react';
import { CartContext } from '../context/CartContext';
import { BsShieldFillCheck, BsShieldFillX } from 'react-icons/bs';
import './CartMenuPicker.css';

const CartMenuPicker = ({ menu, categories }) => {
  const { updateMenuChoice, menuChoices, removeFromCart } = useContext(CartContext);
  const uniqueId = menu.uniqueId;
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if (menuChoices[uniqueId]?.selectedItems) {
      setSelectedItems(menuChoices[uniqueId].selectedItems);
    }
    //console.log('Menu Picker Details:', menu, menuChoices[uniqueId]);
  }, [menuChoices[uniqueId], uniqueId, menu]);

  const handleSelect = (item) => {
    let updatedSelection = selectedItems.includes(item) ? selectedItems.filter(i => i !== item) : [...selectedItems, item];
    if (updatedSelection.length > menu.nb[0]) updatedSelection.shift();
    setSelectedItems(updatedSelection);

    const updatedChoice = {
      selectedItems: updatedSelection
    };

    updateMenuChoice(uniqueId, updatedChoice);
  };

  const isComplete = selectedItems.length === menu.nb[0];

  return (
    <li className="cart-menu-picker">
      <div className='infos-base-menu'>
        <button className="del-button" onClick={() => removeFromCart(menu)}>×</button>
        <h2>{menu.nom} ({selectedItems.length}/{menu.nb[0]})</h2>
        <p className='price'>{menu.prix} €</p>
        {isComplete ? <BsShieldFillCheck className="status-icon complete" /> : <BsShieldFillX className="status-icon incomplete" />}
      </div>
      <div className="items-container">
        <h3>Choisissez {menu.nb[0]} items</h3>
        {menu.options.all.map(id => {
          const item = Object.values(categories).flat().find(item => item.id === id);
          return item ? (
            <div
              key={id}
              onClick={() => handleSelect(item)}
              className={`item ${selectedItems.some(selectedItem => selectedItem.id === item.id) ? 'selected' : ''}`}
            >
              {item.nom}
            </div>
          ) : null;
        })}
      </div>
    </li>
  );
};

export default CartMenuPicker;
